// extracted by mini-css-extract-plugin
module.exports = {"messageOrigin":"styles_messageOrigin__3jKcZ","messageSender":"styles_messageSender__3EcBc","template":"styles_template__2p6nD","menu":"styles_menu__2xENq"};